const Footer = () => {
    return (
    <div class="footer">
    Crafted at <a target="_blank" href="https://interosys.com">Interosys</a>
</div>
    )
}

export default Footer;